import { useEffect, useState } from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const SESSION_STORAGE_KEY = 'REACT_QUERY_DEVTOOLS_TOGGLE';

export function ReactQueryDevtoolsToggle() {
  const [showDevtools, setShowDevtools] = useState(false);

  useEffect(() => {
    const value = window.sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (value !== 'false') {
      setShowDevtools(true);
      window.sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');
    }
  }, []);

  if (!showDevtools || process.env.NODE_ENV !== 'development') return null;
  return (
    <ReactQueryDevtools
      initialIsOpen={false}
      toggleButtonProps={{
        style: {
          width: '1rem',
          height: '1rem',
          bottom: '0.5rem',
          left: '-0.25rem',
        },
      }}
    />
  );
}
